import { Typography } from '@mui/material';
import styled from '@emotion/styled';

export const TypographyBase = styled(Typography)(() => ({
    // fontSize: props.fontSize,
    //fontFamily:"Noto Sans JP",
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
}));
export const TypographyBgBule = styled(TypographyBase)(() => ({
    fontSize:'14px',
    padding: '3px 5px',
    color: 'white', 
    fontWeight: 'bold', 
    backgroundColor: '#007cb0'
}));
export const TypographyBgGray = styled(TypographyBase)(() => ({
    fontSize:'30px',
    padding: '3px 5px',
    fontWeight: 'bold', 
    backgroundColor: '#f2f2f2' 
}));
export const TypographyBuleHeader = styled(TypographyBase)(() => ({
    padding: '3px 5px',
    color: 'white', 
    fontWeight: 'bold', 
    backgroundColor: '#007cb0'
}));

export const TypographyNomal = styled(TypographyBase)(() => ({
    fontSize: '0.9rem'
}));

export const TypographyLeftMenuGray = styled(TypographyBase)(() => ({
    fontSize: '0.75rem',    //12px
    color: 'rgb(208, 208, 206)',
}));
export const TypographyLeftMenu = styled(TypographyBase)(() => ({
    fontSize: '0.7rem',    //12px
}));
export const TypographyGray13px = styled(TypographyBase)(() => ({
    color: '#58595b',
    fontSize: '13px',
}));

export const TypographyBold = styled(TypographyBase)(() => ({
    margin: '0',
    fontWeight: 'bold',
}));

export const TypographyBold14px = styled(TypographyBold)(() => ({
    fontSize: '14px',
}));
export const TypographyBold15px = styled(TypographyBold)(() => ({
    fontSize: '15px',
}));
export const TypographyTitle = styled(TypographyBold)(() => ({
    fontSize: '1.0rem',
}));
export const TypographyTitleSmall = styled(TypographyBold)(() => ({
    fontSize: '0.8rem',
}));
export const TypographyTitleLarge = styled(TypographyBold)(() => ({
    fontSize: '1.6rem',
}));
export const TypographySubTitle = styled(TypographyBold)(() => ({
    // padding: '2px 0',
    textAlign: 'left',
    paddingLeft: '16px',
    // marginBottom: '8px',
    borderLeft: '2px solid #007CB0'
}));

export const TypographyBreakWord = styled(Typography)(() => ({
    wordBreak: 'break-word',
}));

export const TypographyBreakWordSmall = styled(TypographyBreakWord)(() => ({
    fontSize: '0.8rem'
}));

export const TypographyBreakWordGraySmall = styled(TypographyBreakWordSmall)(() => ({
    color: '#6C6C6C',
}));
export const TypographyBreakWordGraySmallR = styled(TypographyBreakWordGraySmall)(() => ({
    paddingRight: '10px',
}));

export const TypographySmallBold = styled(Typography)(() => ({
    fontSize: '0.7rem',
    fontWeight: 'bold',
}));



